module.exports = __webpack_public_path__ + "static/img/brees-2014-slide-5.e092956.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2014-slide-5.jpg
// module id = ZBgu
// module chunks = 1